<template>
    <div class="genomics-protein-content">
        <div class="genomics-protein-header">
            <span class="close-modal iconfont icon-guanbishixin" @click="cancel"></span>
            Add domains for {{ geneName }} {{ partName }}
        </div>
        <div class="genomics-protein-form">
            <a-form>
                <a-row class="input-row">
                    <a-col class="left" :span="24">
                        <a-form-item label="Domain Name"
                            :validate-status="isSubmit && !formData.domainName ? 'error' : ''"
                            :help="isSubmit && !formData.domainName ? 'Please input your Domain Name!' : ''">
                            <a-input v-model="formData.domainName" placeholder="Please input your Domain Name!" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row class="input-row">
                    <a-col class="left" :span="24">
                        <a-form-item label="Amino Acids Range"
                            :validate-status="isSubmit && (!formData.start || !formData.stop) ? 'error' : ''"
                            :help="isSubmit && (!formData.start || !formData.stop) ? 'Please input your Start and End!' : ''">
                            <a-row class="input-row">
                                <a-col class="left" :span="11">
                                    <a-input v-model="formData.start" placeholder="Start" />
                                </a-col>
                                <a-col :span="2"><span class="genomics-protein-line">—</span></a-col>
                                <a-col :span="11">
                                    <a-input v-model="formData.stop" placeholder="End" />
                                </a-col>
                            </a-row>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row class="input-row">
                    <a-col class="left" :span="24">
                        <a-form-item label="Colour" :validate-status="isSubmit && !formData.color ? 'error' : ''"
                            :help="isSubmit && !formData.color ? 'Please input your Colour!' : ''">
                            <a-row class="input-row">
                                <a-col class="left" :span="10">
                                    <a-popover placement="bottomLeft">
                                        <template slot="content">
                                            <chrome-picker v-model="colors" @input="updateColor"></chrome-picker>
                                        </template>
                                        <template slot="title">
                                            <span>Title</span>
                                        </template>
                                        <a-button class="genomics-chrome-picker"
                                            :style="{ backgroundColor: colors.hex }">
                                            <span class="iconfont icon_oval"></span>
                                        </a-button>
                                    </a-popover>
                                </a-col>
                                <a-col :span="14">
                                    <a-input v-model="formData.color" @change="changeColor"
                                        placeholder="Please input your Colour!" />
                                </a-col>
                            </a-row>

                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </div>
    </div>
</template>

<script>
import { Chrome } from 'vue-color'
export default {
    props: {
        queryData: {
            type: Object,
            default: () => { },
        },
        geneName: {
            type: String,
            default: () => { },
        },
        partName: {
            type: String,
            default: () => { },
        }
    },
    components: {
        'chrome-picker': Chrome,
    },
    data() {
        return {
            // colors: { hsb: { h: 206, s: 0.35, l: 0.83 } },
            colors: '#194d33',
            isSubmit: false,
            formData: {
                domainName: "",
                color: "",
                start: "",
                stop: "",
            }
        }
    },
    mounted() { },
    methods: {
        updateColor(value) {
            this.formData.color = value.hex;
        },
        changeColor() {
        },
        cancel() {
            this.$emit('cancel');
        },
        submit() {
            this.isSubmit = true;
            this.$nextTick(() => {
                const isPass =
                    document.querySelectorAll(".ant-form-explain").length == 0;
                if (isPass) {
                    let json = {
                        "description": "",
                        "name": this.formData.domainName,
                        "start": this.formData.start * 1,
                        "stop": this.formData.stop * 1,
                        "refseq": this.partName,
                        "color": this.formData.color,
                        "pfam": "",
                        "cdd": 't' + new Date().getTime(),
                        "smart": null,
                        "tigrfam": null
                    };
                    this.$emit('proteinUpdate', json);
                    this.$emit('cancel');
                }
            });

        }
    }

}
</script>

<style lang="scss" scoped>
.genomics-protein-content {
    position: relative;
    padding: 40px 15px 40px 15px;

    .genomics-protein-line {
        color: #979797;
    }

    .genomics-chrome-picker {
        width: 152px;
        vertical-align: middle;
        background-color: #E70E0E;
        text-align: right;
        padding: 0 0;

        .iconfont {
            position: relative;
            top: -1px;
            right: -1px;
            height: 32px;
            width: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 0 3px 3px 0;
        }

        .icon_oval {
            background: url(../../assets/image/homeImg/icon_oval.png) center no-repeat;
            background-color: #ececec;
            background-size: 65%;
        }
    }

    .genomics-protein-header {
        position: absolute;
        top: -15px;
        left: 0;
        right: 0;
        height: 40px;
        border-bottom: 1px solid #F0F2F5;
        padding-left: 3px;
    }

    .close-modal {
        position: relative;
        top: 1px;
        cursor: pointer;
        padding: 3px 0 3px 5px;
        display: inline-block;
        color: #E51313;
    }

    /deep/ .ant-form-item {
        margin-bottom: 0;
    }

    .left {
        padding-right: 26px;
    }

    .right {
        padding-left: 26px;

    }
}
</style>